import EmptyResult from 'components/others/EmptyResult';
import LeadTableRow from './LeadTableRow';
import type { LeadsTableProps } from './types';

const LeadsTableBody = ({ leadsList, fetchLeads, setClientInfoId, setTasksLeadId, setNewSale }: LeadsTableProps) => {
    return (
        <tbody>
            {leadsList &&
                leadsList?.map((lead) => (
                    <LeadTableRow
                        key={lead.ID}
                        lead={lead}
                        fetchLeads={fetchLeads}
                        setClientInfoId={setClientInfoId}
                        setTasksLeadId={setTasksLeadId}
                        setNewSale={setNewSale}
                    />
                ))}

            {leadsList.length === 0 && (
                <tr>
                    <td colSpan={5}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default LeadsTableBody;
